import React from 'react';
import { FRONT_BUSINESS_URL } from '../../routing';
import { createBusinessPageShareText } from '../../Social/TwitterButton';
import SnsButtonGroup from '../SnsButtonGroup';

interface XsSnsShareButtonProps {
  id: number;
  name: string;
  regionName?: string | null;
}

// 事業者ページで単独利用するために定義。ReactRailsから呼ばれる。
export const XsSnsShareButton = ({
  id,
  name,
  regionName,
}: XsSnsShareButtonProps) => {
  const businessPageUrl = FRONT_BUSINESS_URL.replace(':id', id.toString());
  const twitterShareText = createBusinessPageShareText(
    name,
    businessPageUrl,
    regionName || '',
  );
  return (
    <SnsButtonGroup
      hiddenProps={{ smUp: true }}
      justify="center"
      gutterBottom
      loaded
      tweetText={twitterShareText}
      url={businessPageUrl}
    />
  );
};

export default XsSnsShareButton;
